import React from 'react';
import WorkEdit from './WorkEdit';

/**
 * 作業実績一覧・編集
 *
 * @param {*} props
 */
const WorkResultEdit = props => <WorkEdit isWorkSchedule={false} {...props} />;

export default WorkResultEdit;



// WEBPACK FOOTER //
// ./src/pages/WorkResultEdit.jsx